export const COLLECTION_NAME = "stories";

export { createStory } from "./createStory";
export { deleteStory } from "./deleteStory";
export { updateStory } from "./updateStory";
export { useDocument } from "./useDocument";
export { useFetchStoriesByIds, useFetchPublicStories } from "./fetchStories";
export { useTogglePublic } from "./togglePublic";
